__turbopack_context__.v({
  "content": "zxFHLq_content",
  "left": "zxFHLq_left",
  "modalBody": "zxFHLq_modalBody",
  "modalContent": "zxFHLq_modalContent",
  "modalFooter": "zxFHLq_modalFooter",
  "modalFooterActions": "zxFHLq_modalFooterActions",
  "orderTotal": "zxFHLq_orderTotal",
  "right": "zxFHLq_right",
  "secondary": "zxFHLq_secondary",
  "spinner": "zxFHLq_spinner",
});
